export enum SessionStorageKey {
	OktaRedirect = 'OKTA_REDIRECT',
	CsrfToken = 'csrfToken',
	PublicAppLogin = 'PUBLIC_APP_LOGIN',
	Session = 'session',
	Config = 'config',
	PAS_AS_OF_DATE = 'pasAsOfDate'
}
